import React, { Component } from 'react'

export default class LinkedinSocial extends Component {

  componentDidMount() {
    this.preloadWidgetScript()
  }
  
  preloadWidgetScript = () => {
    const script = document.createElement('script')
    script.async = true
    script.src = '//platform.linkedin.com/badges/js/profile.js'
    document.body.appendChild(script)
  }

  username = () => {
    return this.props.url.split('/').filter(Boolean).slice(-1)
  }

  render() {
    return(
      <div hidden={this.props.hidden}>
        <div  className   ="LI-profile-badge"
              data-version="v1"
              data-size   ="medium"
              data-locale ="en_US"
              data-type   ="vertical"
              data-theme  ="light"
              data-vanity ={this.username()}>
        </div>
      </div>
    )
  }
}

LinkedinSocial.defaultProps = {
  hidden:     true,
  url:        'https://www.linkedin.com/in/scottlockhart'
}


// WEBPACK FOOTER //
// client/components/social/LinkedinSocial.js